<template>
  <span class="qrTimer">{{ timerText }}</span>
</template>

<script>
export default {
  
  data() {
    return {
      timerText: "09:59",
      timer: 600,
      qrTimer: undefined
    };
  },
  created() {
    this.init();
  },
  methods: {
    handleReset() {
      clearInterval(this.qrTimer);
      this.timerText = "09:59"
      this.timer = 600
      this.init()
    },
    init() {
      var min = this.timer / 60;
      min = min - 1;
      this.qrTimer = setInterval(() => {
        this.timer--;
        let second = this.timer % 60;
        if (second === 0) {
          if (min === 0) {
            this.timerText = "已失效";
            clearInterval(this.qrTimer);
            return;
          } else {
            min = min - 1;
          }
        }
        this.timerText =
          "0" + min + ":" + (second < 10 ? "0" + second : second);
      }, 1000);
    }
  }
};
</script>

<style>
.qrTimer {
  color: #ff5129;
}
</style>



// WEBPACK FOOTER //
// src/components/CountDown.vue